import { createLandingPageContent } from '@/domain/landing/LandingPageContent';

export class StaticLandingContentRepository {
  getLandingPageContent() {
    return createLandingPageContent({
      hero: {
        badge: 'Sân chơi trí tuệ thế hệ mới',
        title: 'Khám phá thế giới tri thức mỗi ngày',
        subtitle:
          'QuizAtelier biến việc học thành trải nghiệm tương tác cho giáo viên, phụ huynh và học sinh.',
        primaryCta: 'Đăng ký',
        secondaryCta: 'Đăng nhập',
        trialCta: 'Bắt đầu ngay với vai trò khách',
        imageUrl:
          'https://lh3.googleusercontent.com/aida-public/AB6AXuBTvxB1mkOswzAYIx94nkgRrY1IHxC2e9p6lfhQxGX4nacPBh2fzthsWxHf1UCHbtRjRVY3hgXWqkYvGzgvVZp_qq_8QpyVyAooF7OK6vGdShu5M2imaDE4yjdZ9q1hisln3FTdkhQPeHdswkaLgXct_yP_ekT7HzC6cxTNZy9EbUmGo5ykV_vRMGR9IzJRzp41eM0IFH-G1dt6PiDqlXKrkIk53ZesMSso5-IipBrlNjhOqd0ufs4HuZr9lsu2C_Py_T2UZOfiyYY',
      },
      features: [
        {
          id: 'create',
          title: 'Sáng tạo (Create)',
          description: 'Tạo nhanh bộ câu hỏi với mẫu sẵn, hình ảnh và âm thanh sinh động.',
          icon: 'edit_square',
        },
        {
          id: 'play',
          title: 'Trải nghiệm (Play)',
          description: 'Học và chơi qua quiz theo thời gian thực trên nhiều thiết bị.',
          icon: 'rocket_launch',
        },
        {
          id: 'track',
          title: 'Theo dõi (Track)',
          description: 'Báo cáo kết quả, điểm mạnh và lỗ hổng kiến thức theo từng người học.',
          icon: 'analytics',
        },
      ],
      audiences: [
        {
          role: 'Quản trị viên',
          summary: 'Quản lý hệ thống và nội dung trường học.',
          tag: 'Admin',
          imageUrl:
            'https://lh3.googleusercontent.com/aida-public/AB6AXuCvICi9FwXCDKh7AuWfQ7yuormrPJi3aB5SCYUbA7DArezQWbKx_qnSb6kWT0ZDOLlzmpz6-uGY5DbvqxKCCWKDyPjUphh3UwAkB3yaKEY0gIgGveya7j_r5C-C_aoHkzDw1aPB81zifdaICSl91aLJlQl1h6cOecu4LqLYBQ4fuPsbfH2YKytZkDq4_o4phWuxeDszjuxHQE-lqGJJm6POPMrBheure4qaovA55I4PuQuOgArqnST7I8lbnrMyqxdKr0O5uGHJ0_0',
        },
        {
          role: 'Giáo viên',
          summary: 'Thiết kế bài giảng và theo dõi học sinh.',
          tag: 'Teacher',
          imageUrl:
            'https://lh3.googleusercontent.com/aida-public/AB6AXuAYVPToSFJgCkw307L-1Z_vFh4ixQaHLVwP1VZCIeGHl7JbWAxVgbdvLIAxGkO1RDX0UvKRgiidjsFk7SQEKsQqKCtwgL6LVJpPWwElJJie1WZAr77x78whnreUFEeVEZPXTqDPGtxz8NWMdoJpFTA8-4HNF2Yiblk6ATh0KJernQ8Kjfz2JIO9p66d7D11FQaWEU_Df9V-uwDVNfm5wzqbu7dq421DnEHI4FDoL0XvjJg7E_SPrUiVQUX8Na8-A_vxE4PXthxYQ80',
        },
        {
          role: 'Gia sư',
          summary: 'Hướng dẫn 1-1 và tạo bài tập bổ trợ.',
          tag: 'Tutor',
          imageUrl:
            'https://lh3.googleusercontent.com/aida-public/AB6AXuCj4mfgIxCZBvbkjJPk75ij-is_epmr4Ph7gfStOGWdfNgRMvht8sEYCyjJZ7Ge1P8FOwveio9cqWxlipLDB963BcIADApOB-HRhAnLQexRkZdD419ijN5mpn2x7qHCh5ElmNdE89Vp0vOh6t7fbKOrRNx231YnxFUCkzpeiSw74zKo7gk_RWEyqSHOCWcbE-PVPA6BP4DQC_3FA6wC0PUqwzMBBrO7_Kq9VRtHUswL-hkZT1mx7iWxrV5D_xa1Jzcrn7CpnhJt6ts',
        },
        {
          role: 'Phụ huynh',
          summary: 'Đồng hành cùng con trong mỗi giờ học.',
          tag: 'Parent',
          imageUrl:
            'https://lh3.googleusercontent.com/aida-public/AB6AXuCt6iGVA9JjHtEGBFBuzWb-LDvyw1PcVzqi_m6GtBJ9Ls3-13-be07DIPfDlct8uv8hRq58VTWBasHCFd7OqWsAZNJ28qSI4dNSrG_TqgUnnGbexHB-HjtcVdDHG8IHuMTbPCpe_NZ0Z4lqGHbGA6r3Xh2CwwMVxs80xDeMXfS6P9bIlyL3bg2xSBscS0lNz5znPsd31tDzTa1vHZSbLNNvDRpi2p3La5mULeFC727DBkTdd9p7ttDCpI8rTKIViKxv725VFEzHcVk',
        },
        {
          role: 'Học sinh',
          summary: 'Tự do học hỏi qua trò chơi thú vị.',
          tag: 'Student',
          imageUrl:
            'https://lh3.googleusercontent.com/aida-public/AB6AXuDzm2EMm2KEXyGwpqD63NR8oXrffBNDOciL1o5UiWWvDAp65lqBBZir4UD3j4VPu07tRGAeHS6EVOhnVRTEHN0GhQS-01TieSw-mfCj_aJBocpBLCfXTPvNtm0U6ALAvK5CFuC-KMMhN9jMm9kSiB-3tyewBZf6X78AAw2Su4CbUIm_zJXy_4WAhUgsq-CS-7nUVK-ZXyZnNAUf3gIA61U0yMD5OyrQ5kSviQhfvMC_swGpZOZbFL8pHqYiw_QGF1zv_HfOpUhcMRk',
        },
      ],
      footer: {
        productLinks: ['Tạo Quiz', 'Thư viện câu hỏi', 'Tải ứng dụng', 'Gói Pro'],
        supportLinks: ['Trung tâm trợ giúp', 'Cộng đồng', 'An toàn và Bảo mật', 'Liên hệ'],
        aboutLinks: ['Câu chuyện thương hiệu', 'Tuyển dụng', 'Blog giáo dục', 'Báo chí'],
      },
    });
  }
}

